/* Asset: djuce-cart-message.js */
class DjuceProgressMessage extends HTMLElement {
  constructor() {
    super();
    //this.cartCount = 0;
    this.cartCount = parseInt(this.getAttribute('data-cart-count'), 10) || 0;
    
    try {
      const localesScript = this.querySelector('.dpm-locales-json');
      this.locales = JSON.parse(localesScript.textContent);
    } catch (e) {
      console.error("DCM: Failed to parse locales.");
      this.locales = { 
        msg_0: "→ Buy <strong>2 items</strong> to get <strong>free shipping + 10% off</strong> your order",
        msg_1: "→ Add <strong>1 more product</strong> to get <strong>free shipping + 10% off</strong> your order",
        msg_2: "You have 2 products — add <strong>1 more</strong> to unlock 20% off your entire order",
        msg_3: "✓ Best price unlocked — <strong>20% off + free shipping</strong> on your entire order"
      };
    }
  }

  async connectedCallback() {
    this.render();
    await this.fetchCartState();
    
    this.ampUpdateHandler = this.handleAmpCartUpdate.bind(this);
    window.addEventListener('djuce:cart:updated', this.ampUpdateHandler);
  }

  disconnectedCallback() {
    window.removeEventListener('djuce:cart:updated', this.ampUpdateHandler);
  }

  async fetchCartState() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (response.ok) {
        const cart = await response.json();
        this.cartCount = cart.item_count || 0;
      }
    } catch (error) {
      console.warn('DCM: Cart fetch failed.');
    } finally {
      this.render();
      this.classList.add('loaded');
    }
  }

  handleAmpCartUpdate(event) {
    const cart = event.detail;
    if (cart && typeof cart.item_count !== 'undefined') {
      this.cartCount = cart.item_count;
      this.render();
    }
  }

  render() {
    const textEl = this.querySelector('.dpm-message-text');
    if (!textEl) return;

    // Reset all tier classes first
    this.classList.remove('tier-0', 'tier-1', 'tier-2', 'tier-3');

    // Apply the correct text and CSS tier class
    if (this.cartCount === 0) {
      textEl.innerHTML = this.locales.msg_0;
      this.classList.add('tier-0');
    } else if (this.cartCount === 1) {
      textEl.innerHTML = this.locales.msg_1;
      this.classList.add('tier-1');
    } else if (this.cartCount === 2) {
      textEl.innerHTML = this.locales.msg_2;
      this.classList.add('tier-2');
    } else {
      textEl.innerHTML = this.locales.msg_3;
      this.classList.add('tier-3');
    }
  }

}

if (!customElements.get('djuce-progress-message')) {
  customElements.define('djuce-progress-message', DjuceProgressMessage);
}
